import {
  DEFAULT_HP_CONTACT_DISTRIBUTOR_ROLE,
  DEFAULT_HP_CONTACT_RESELLER_ROLE,
  DEFAULT_HP_CONTACT_RETAIL_ROLE,
} from 'legacy/lut/classes/models/partner360/IFormHPContacts'

interface IGetDefaultHpContactRole {
  isDistributor: boolean
  isRetailProgramType: boolean
}

export const getDefaultHpContactRole = ({
  isDistributor,
  isRetailProgramType,
}: IGetDefaultHpContactRole) => {
  if (isDistributor) {
    return DEFAULT_HP_CONTACT_DISTRIBUTOR_ROLE
  }

  if (isRetailProgramType) {
    return DEFAULT_HP_CONTACT_RETAIL_ROLE
  }

  return DEFAULT_HP_CONTACT_RESELLER_ROLE
}
